/**
 * Routing provider, based on Mithril. LEGACY, DO NOT USE.
 */
import { route } from 'mithril'
import BaseClass from '../application/BaseClass'
import { createElement } from '../utils/dom'
import { getIsSlideshow } from '../application/pageDataObject'
import { empty as emptyComponent } from '../utils/component'
import { routes } from '../organizedByType/routes/slideshowRoutes'

let initialRoute = getIsSlideshow() ? '/' : window.location.pathname

const ROUTE_CONFIG = {
  DEFAULT_ROUTE: {
    [initialRoute]: emptyComponent,
  },
  DEFAULT_ROUTE_URL: initialRoute,
  ROUTE_COMPONENTS: [routes],
}

class RoutingProvider extends BaseClass {
  constructor(routeList) {
    super()
    route.mode = 'pathname'
    let { DEFAULT_ROUTE_URL: defaultUrl, DEFAULT_ROUTE: allRoutes } = ROUTE_CONFIG
    routeList.forEach(routeToRegister => Object.assign(allRoutes, routeToRegister))
    route(createElement('div'), defaultUrl, allRoutes)
    this.merge({
      routes: allRoutes,
      routingMode: route.mode,
    })
  }
}

export default RoutingProvider.create(ROUTE_CONFIG.ROUTE_COMPONENTS)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/routingProvider.js